export type UserExtraDetailsPayload = {
  project?: string[];
  analysis?: string[];
  pipe_inventory?: string[];
  map?: string[];
  devices?: string[];
};

/** Normalize API user_extra_details (object or JSON string). */
export function parseUserExtraDetails(raw: unknown): UserExtraDetailsPayload | null {
  if (raw == null || raw === '') return null;

  let value: unknown = raw;
  if (typeof raw === 'string') {
    try {
      value = JSON.parse(raw);
    } catch {
      return null;
    }
  }

  if (typeof value !== 'object' || Array.isArray(value)) return null;
  const record = value as Record<string, unknown>;

  const pipeInventory =
    record.pipe_inventory ?? record.pipeInventory ?? record['pipe-inventory'];

  return {
    project: Array.isArray(record.project) ? (record.project as string[]) : undefined,
    analysis: Array.isArray(record.analysis) ? (record.analysis as string[]) : undefined,
    pipe_inventory: Array.isArray(pipeInventory) ? (pipeInventory as string[]) : undefined,
    map: Array.isArray(record.map) ? (record.map as string[]) : undefined,
    devices: Array.isArray(record.devices) ? (record.devices as string[]) : undefined,
  };
}
